module.exports = (__webpack_require__(16))(237);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/body/SearchResultsView.js from dll-reference girder_lib
// module id = 175
// module chunks = 0